import { useState } from "react";
import InputPropsType from "../../Types/InputPropsType";

const StyledInput = ({
  type = "text",
  text,
  placeholder,
  onChange,
  className = "styledInput",
}: InputPropsType) => {
  const [value, setValue] = useState();

  function onInput(e: any) {
    if (type === "number") {
      let answer = e.target.value.replace(/[^0-9]/g, "");

      setValue(answer);
      onChange(answer);
    } else {
      onChange(e);
    }
  }

  return (
    <div className={className}>
      <div>{text}</div>
      <input type={type} value={value} placeholder={placeholder} onChange={onInput} />
    </div>
  );
};

export default StyledInput;
